<template>
  <nav
    class="navbar navbar-light d-none d-md-flex z-index-fix fixed-top"
    id="topbar"
  >
    <div class="container-fluid">
      <router-link to="/home/geral">
        <div class="d-flex align-items-center">
          <Logo type="square" />
          <Typograph variant="pagesubtitle" class="mx-2 mt-2 text-dark"
            >{{ session?.partnership?.name || "GreeZon" }}
          </Typograph>
        </div>
      </router-link>
      <div class="navbar-user">
        <div class="dropdown">
          <a
            href="#"
            class="avatar avatar-sm dropdown-toggle d-flex align-items-center w-fix"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <Typograph variant="subtitle" class="text-dark me-2">
              {{ session?.name }}
            </Typograph>
            <AccountImage v-if="session" :userSession="session" />
          </a>

          <div class="dropdown-menu dropdown-menu-end">
            <router-link
              :to="{
                name: routes.admins.detail?.name,
                params: { id: session?.id },
              }"
              class="dropdown-item"
              >Minha conta</router-link
            >
            <hr class="dropdown-divider" />
            <router-link
              :to="routes.login.path"
              class="dropdown-item text-danger"
              >Sair</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useMainStore } from "@/infra/store";
import { computed } from "vue";
import { routes } from "@/presentation/router";
import AccountImage from "./AccountImage.vue";
const session = computed(() => useMainStore().session);
</script>

<style scoped>
.w-fix {
  width: unset;
}
.z-index-fix {
  z-index: 1031;
}
</style>
